import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { useIntl } from 'react-intl-next';
import { invalidFieldContainerStyles } from '../common/questionWrappers';
import { EditDate } from './EditDate';
import { EditTime } from './EditTime';
import { messages } from './messages';
export var EditDateTime = function EditDateTime(_ref) {
  var id = _ref.id,
    dateValue = _ref.dateValue,
    timeValue = _ref.timeValue,
    isInvalid = _ref.isInvalid,
    isRequired = _ref.isRequired,
    onDateChange = _ref.onDateChange,
    onTimeChange = _ref.onTimeChange,
    label = _ref.label;
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(DateTimePickerContainer, {
    isInvalid: isInvalid
  }, /*#__PURE__*/React.createElement(EditDate, {
    id: id,
    value: dateValue,
    isInvalid: false,
    isRequired: isRequired,
    onChange: onDateChange,
    label: intl.formatMessage(messages.dateLabel, {
      label: label
    })
  }), /*#__PURE__*/React.createElement(EditTime, {
    id: id + '-time',
    value: timeValue,
    isInvalid: false,
    isRequired: isRequired,
    label: intl.formatMessage(messages.timeLabel, {
      label: label
    }),
    onChange: onTimeChange
  }));
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var DateTimePickerContainer = styled.div({
  display: 'flex',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> div': {
    width: '50%'
  }
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
function (props) {
  return props.isInvalid && invalidFieldContainerStyles;
});